import {TranslateService} from '@ngx-translate/core/src/translate.service';
import {SelectItem} from 'primeng/components/common/api';

export class ClusterType {
  id?: string;
  code: string;
  description?: string;
}


// WEBPACK FOOTER //
// ./src/app/models/loyalty-cluster-type.model.ts